function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import Loading from 'researcher/components/Loading';
import { getChinaLocalization } from 'shared/account/reducer';
import { downloadPaddleReceipt } from '../actions';
import FapiaoStatus from './FapiaoStatus';
import PaddleActionsDropdown from './PaddleActionsDropdown';
import './OrdersTable';
function PaddleInvoices(_ref) {
  var paddleInvoices = _ref.paddleInvoices,
    onFapiaoCancelled = _ref.onFapiaoCancelled;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var dispatch = useDispatch();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    orders = _useState2[0],
    setOrders = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var isChinaUser = useSelector(getChinaLocalization);
  useEffect(function () {
    setLoading(true);
    if (paddleInvoices && paddleInvoices.payments) {
      var processedOrders = paddleInvoices.payments.map(function (payment, index) {
        return {
          id: index + 1,
          date: payment.date,
          product: payment.productName,
          productType: getProductType(payment.productName),
          amount: parseFloat(payment.paidAmount.amount),
          currency: payment.paidAmount.currency,
          receiptCode: payment.receiptCode,
          netAmount: parseFloat(payment.netAmount.amount),
          netCurrency: payment.netAmount.currency,
          fapiao: payment.fapiao,
          hasFapiao: payment.fapiao !== null,
          paymentId: payment.paymentId
        };
      });
      setOrders(processedOrders);
    } else {
      setOrders([]);
    }
    setLoading(false);
  }, [paddleInvoices], 2000);
  var getProductType = function getProductType(productName) {
    var name = productName.toLowerCase();
    if (name.includes('translation')) {
      return 'premium-translation';
    }
    if (name.includes('premium')) {
      return 'premium';
    }
    if (name.includes('ithenticate') || name.includes('report')) {
      return 'report';
    }
    return 'default';
  };
  var formatDate = function formatDate(dateString) {
    var date = new Date(dateString);
    return date.toLocaleDateString();
  };
  var formatCurrency = function formatCurrency(amount, currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD'
    }).format(amount);
  };
  var getProductDotClass = function getProductDotClass(productType) {
    var classes = {
      premium: 'product-premium',
      report: 'product-report',
      'premium-translation': 'product-premium-translation',
      default: 'product-default'
    };
    return classes[productType] || 'product-default';
  };
  if (loading) {
    return /*#__PURE__*/React.createElement(Loading, null);
  }
  if (!orders || orders.length === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "w-75 mx-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "orders-container"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "orders-title"
    }, /*#__PURE__*/React.createElement(T, {
      source: "My Orders"
    })), /*#__PURE__*/React.createElement("p", {
      className: "orders-description"
    }, /*#__PURE__*/React.createElement(T, {
      source: "rubriq.no-orders"
    }))));
  }
  var handleDownloadReceipt = function handleDownloadReceipt(paymentId) {
    dispatch(downloadPaddleReceipt(paymentId));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "w-75 container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "orders-container"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "orders-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "My Orders"
  })), /*#__PURE__*/React.createElement("p", {
    className: "orders-description"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.paddle-invoice-page-description"
  })), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-orders-table-wrapper"
  }, /*#__PURE__*/React.createElement("table", {
    className: "rubriq-orders-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Date')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Date"
  })), /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Product')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Product"
  })), /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Amount')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Amount"
  })), /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Invoice #')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Invoice #"
  })), isChinaUser && /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Fapiao')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Fapiao"
  })), isChinaUser && /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Actions'),
    className: "text-end"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Actions"
  })))), /*#__PURE__*/React.createElement("tbody", null, orders.map(function (order) {
    return /*#__PURE__*/React.createElement("tr", {
      key: order.id
    }, /*#__PURE__*/React.createElement("td", null, formatDate(order.date)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "product-display"
    }, /*#__PURE__*/React.createElement("span", {
      className: "product-dot ".concat(getProductDotClass(order.productType))
    }), /*#__PURE__*/React.createElement(T, {
      source: order.product
    }))), /*#__PURE__*/React.createElement("td", null, formatCurrency(order.amount, order.currency)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("button", {
      "aria-label": t('Download Receipt'),
      type: "button",
      onClick: function onClick() {
        return handleDownloadReceipt(order.paymentId);
      }
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-light fa-file-arrow-down",
      className: "me-1",
      "data-testid": "rubriq-download-receipt"
    }), /*#__PURE__*/React.createElement(T, {
      source: "Download"
    }))), isChinaUser && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FapiaoStatus, {
      fapiao: order === null || order === void 0 ? void 0 : order.fapiao,
      fapiaoCreationUrl: "/rubriq/".concat(order === null || order === void 0 ? void 0 : order.receiptCode, "/fapiao")
    })), isChinaUser && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "dropdown-container"
    }, /*#__PURE__*/React.createElement(PaddleActionsDropdown, {
      onFapiaoCancelled: onFapiaoCancelled,
      order: order
    }))));
  }))))));
}
export default PaddleInvoices;